import { Injectable } from '@angular/core';
import { PortalFieldConfig } from '@portal/form/data-access';
import { BANK_STATEMENT } from '@core/data-access';

@Injectable({ providedIn: 'root' })
export class BankStatementFormFieldConfigService {
  initBankStatementFieldConfig(): PortalFieldConfig[] {
    return [
      {
        template: '<div class="portal-paragraph">Upload statement from the <span class="font-bold">last 6 months.</span></div>',
      },
      {
        key: 'files',
        type: 'file',
        validators: { validation: ['maxSelectFile', 'minSizeFile', 'maxSizeFile', 'fileName'] },
        className: 'field-columns',
        props: {
          required: true,
          multiple: true,
          min: BANK_STATEMENT.MIN_SIZE,
          max: BANK_STATEMENT.MAX_SIZE,
          maxLength: BANK_STATEMENT.MAX_FILE,
          confirmBeforeChange: true,
          acceptMimeTypes: Array.from<string>(BANK_STATEMENT.MIME_TYPE),
        },
      },
    ];
  }
}
